import { useController } from 'react-hook-form'

import { FocusTarget } from '@/components/form/focus-target'
import { CurrencyInput, CurrencyInputProps } from '@/components/ui/currency-input'

interface CurrencyInputFormFieldProps
  extends Omit<CurrencyInputProps, 'value' | 'onChange' | 'error'> {
  name: string
}

export const CurrencyInputFormField = ({ name, ...props }: CurrencyInputFormFieldProps) => {
  const { field, fieldState } = useController({ name })

  return (
    <FocusTarget fieldRef={field.ref}>
      <CurrencyInput
        {...props}
        name={field.name}
        value={field.value != null ? String(field.value) : ''}
        error={fieldState.error?.message}
        onBlur={field.onBlur}
        onChange={field.onChange}
      />
    </FocusTarget>
  )
}
